import { render, staticRenderFns } from "./loyalty-tiers.vue?vue&type=template&id=451b32ff&scoped=true"
import script from "./loyalty-tiers.vue?vue&type=script&lang=js"
export * from "./loyalty-tiers.vue?vue&type=script&lang=js"
import style0 from "./loyalty-tiers.vue?vue&type=style&index=0&id=451b32ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b32ff",
  null
  
)

export default component.exports